/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
    // 제품 목록 조회
    async index(data?: any) {
        return camelize(
            await $axios.get(`/emergency/rentals`, snakelize({ params: data }))
        );
    },

    // 제품 조회
    async show(data?: any) {
        return camelize(
            await $axios.get(
                `/emergency/rentals${data.id}`,
                snakelize({ params: data })
            )
        );
    },

    // 제품 수정
    async update(data?: any) {
        await $axios.patch(`/emergency/rentals${data.id}`, snakelize(data));
    },

    // 제품 등록
    async store(data?: any) {
        return camelize(
            await $axios.post(`/emergency/rentals`, snakelize(data))
        );
    },

    // 제품 등록
    async hide(data?: any) {
        return camelize(
            await $axios.post(
                `/emergency/rentals${data.id}/hide`,
                snakelize(data)
            )
        );
    },

    // 제품 제거
    async delete(data?: any) {
        return camelize(
            await $axios.delete(
                `/emergency/rentals${data.id}`,
                snakelize({ params: data })
            )
        );
    },
});
